import * as React from 'react'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { Panel } from '@amzn/dvui/dist/Panel'
import { Text } from '@amzn/dvui/dist/Text'
import * as st from './heroQuickPromo.module.scss'

export interface IHeroQuickPromoProps {
  title?: WpsRuntime.atv.wps.DVString,
  content?: WpsRuntime.atv.wps.DVString
  image?: WpsRuntime.atv.wps.Image
}

export const HeroQuickPromo = ({ title, content, image }: IHeroQuickPromoProps) =>
  (title || content) ? (
    <article className={st.avHqlContainer}>
      <Panel className={`avu-clearfix ${st.avHqpBanner}`}>
        {image && <HQPImageWithLink {...image}/>}
        <div>
          <header>
            <Text string={title} tag='small'/>
          </header>
          <p>
            <Text string={content} tag='small'/>
          </p>
        </div>
      </Panel>
    </article>
  ) : null

const HQPImageWithLink = ({ path, alt, link}: WpsRuntime.atv.wps.Image) =>
  path ? (
    link ? (
      <a href={link.href} aria-label={link.ariaLabel}>
        <HQPImage { ...{path, alt} } />
      </a>
    ) : (
      <HQPImage { ...{path, alt} } />
    )
  ) : null

interface HQPImageProps {
  path: string,
  alt?: string,
}

const HQPImage = ({ path, alt }: HQPImageProps) =>
  <div className={st.avUpsellImage}>
    <img src={path} alt={alt} />
  </div>
